import { Controller } from "@hotwired/stimulus";

// Next to an in-place edited textarea (see `events/_template_field`): while the
// field is open for editing the picker is visible, and the chosen template is
// appended to the textarea.
export default class extends Controller {
  static targets = ["picker", "select"];

  toggle() {
    this.pickerTarget.hidden = !this.textarea;
  }

  insert(event) {
    event.preventDefault();
    if (this.textarea) this.textarea.value += this.selectTarget.value;
  }

  get textarea() {
    return this.element.querySelector("textarea");
  }
}
